var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0033 8.8432C16.7996 8.04692 16.7997 6.75585 16.0034 5.95953C15.2071 5.16321 13.916 5.16317 13.1197 5.95946L5.95923 13.1196C5.57681 13.502 5.36197 14.0207 5.36197 14.5615C5.36197 15.1023 5.57681 15.6209 5.95923 16.0033L13.1197 23.1635C13.916 23.9598 15.2071 23.9597 16.0034 23.1634C16.7997 22.3671 16.7996 21.076 16.0033 20.2797L10.2848 14.5615L16.0033 8.8432Z",
    fill: "#7B848A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1625 8.8432C23.9588 8.04692 23.9588 6.75585 23.1625 5.95953C22.3662 5.16321 21.0752 5.16317 20.2789 5.95946L13.1184 13.1196C12.7359 13.502 12.5211 14.0207 12.5211 14.5615C12.5211 15.1023 12.7359 15.6209 13.1184 16.0033L20.2789 23.1635C21.0752 23.9598 22.3662 23.9597 23.1625 23.1634C23.9588 22.3671 23.9588 21.076 23.1625 20.2797L17.4439 14.5615L23.1625 8.8432Z",
    fill: "#7B848A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.dccf5f07ddcbc7e42f6564a15db2b3b5.svg";
export { ForwardRef as ReactComponent };